module.exports = __webpack_public_path__ + "img/pitch-events-banner-1200X600.4156e2a4.png";